import _map from 'lodash/map';
import Stack from '../../../_components/Stack';
import { FeaturedIcon } from '../../FeaturedIcon';
import { Button } from '../../Button';
import { Link } from '../../Link';
import { containerVariants, descriptionVariants, titleVariants } from '../styles';
import type { EmptyStateDefaultProps } from '../types';
import EmptyStateTitle from '../components/EmptyStateTitle';
import EmptyStateDescription from '../components/EmptyStateDescription';

function EmptyStateDefault(props: EmptyStateDefaultProps) {
  const { title, Icon, variant, description, buttons, size = 'md', learnMore, slotProps } = props;
  const containerClassName = containerVariants({ variant, size });
  const titleClassName = titleVariants({ variant, size });
  const descriptionClassName = descriptionVariants({ size });
  const buttonVariant = size === 'sm' ? 'outline' : 'solid';

  return (
    <Stack
      alignItems="start"
      className={containerClassName}
      direction="column"
      justifyContent="center"
    >
      {Icon ? (
        <FeaturedIcon Icon={Icon} color="gray" size={size} {...slotProps?.featuredIcon} />
      ) : null}
      <Stack className="gap-y-xs items-start">
        <Stack>
          <EmptyStateTitle className={titleClassName} title={title} />
          {description ? (
            <EmptyStateDescription className={descriptionClassName} description={description} />
          ) : null}
        </Stack>
        {learnMore ? (
          <Link
            className="font-semibold"
            color="brand"
            href={learnMore.href}
            size="sm"
            target="_blank"
          >
            {learnMore.label}
          </Link>
        ) : null}
      </Stack>
      {buttons?.length ? (
        <Stack className="gap-x-lg" direction="row">
          {_map(buttons, (button, index) => {
            return (
              <Button
                color="brand"
                key={`${button.label} ${index}`}
                size={size}
                variant={buttonVariant}
                {...button}
              >
                {button.label}
              </Button>
            );
          })}
        </Stack>
      ) : null}
    </Stack>
  );
}

export default EmptyStateDefault;
